































































import { Component, Vue,Inject, Prop, Watch } from 'vue-property-decorator';
import expand from './expand.vue'
import childrenD from './children.vue'

@Component({
  components:{expand,childrenD}
})
export default class extends Vue{
    @Prop({type:Array}) tableData:Array<any>;
    @Prop({type:Array}) columns:Array<any>;
    @Prop({type:Number}) currentPage:Number;
    @Prop({type:Number}) total:Number;
    @Prop({type:Number}) height:Number;
    @Prop({type:Boolean,default:false}) notPagination:Boolean;
    @Prop({type:Boolean,default:false}) loading:Boolean;
    @Prop({type:Boolean,default:false}) showSummary:Boolean;
    @Prop({type:Boolean,default:false}) indexHidden:Boolean;
    @Prop({type:String,default:'mytable'}) id:String;
    @Prop({type:Boolean,default:false}) isSelection:Boolean;
    @Prop({type:Function,}) rowClassName:Function;

    created() {
      console.log(this.columns) 
    }
    handleCurrentChange(val:any){
      this.$emit('handleCurrentChange',val)
    }
    handleSizeChange(val:any){
      this.$emit('handleSizeChange',val)
    }
}
